import React, { useEffect, useState } from "react";
import { Box, Card, CardContent, Typography, CircularProgress } from "@mui/material";
import { sectionBox } from "../styles/ComponentStyles";
import { verifyNewDevice } from "../api/userSessions";
import { useTranslate } from "../components/Translate/TranslateContext";

export default function NewDevice() {
  const { translate } = useTranslate();
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    const token = window.location.hash.replace("#", "");
    if (!token) {
      setStatus("expired");
      return;
    }

    (async () => {
      try {
        const result = await verifyNewDevice(token);
        setStatus(result?.success ? "success" : "expired");
      } catch {
        setStatus("expired");
      }
    })();
  }, []);

  return (
    <Box
      sx={{
        ...sectionBox,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        minHeight: "calc(100vh - 70px)",
        px: 2,
      }}
    >
      <Card
        sx={{
          maxWidth: 400,
          width: "90%",
          textAlign: "center",
          boxShadow: 6,
          borderRadius: 3,
        }}
      >
        <CardContent sx={{ p: 4, display: "flex", flexDirection: "column", alignItems: "center" }}>
          {status === "loading" ? (
            <CircularProgress color="primary" size={48} />
          ) : (
            <>
              <Typography
                variant="h5"
                gutterBottom
                color={status === "success" ? "success.main" : "error.main"}
              >
                {status === "success"
                  ? translate("device_registered_title")
                  : translate("device_expired_title")}
              </Typography>

              <Typography variant="body1" sx={{ mt: 2 }}>
                {status === "success"
                  ? translate("device_registered_message")
                  : translate("device_expired_message")}
              </Typography>
            </>
          )}
        </CardContent>
      </Card>
    </Box>
  );
}
